import React from 'react';
import Buttons from '../Common/Buttons';
import { useLocale } from '../../localization/LocaleContext';
import '../NicheLanding/NicheLandingPage.css';

const featureIcons = [
    // Chart / insights icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
    </svg>,
    // Estimate / clipboard icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
        <line x1="9" y1="12" x2="15" y2="12"/>
        <line x1="9" y1="16" x2="13" y2="16"/>
    </svg>,
    // Brand / star icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>,
];

function FeatureBusiness(){
    const { t } = useLocale();

    const features = [
        { id: 1, icon: featureIcons[0], title: t('smallBusiness.sectionOneTitle'), description: t('smallBusiness.sectionOneDescription') },
        { id: 2, icon: featureIcons[1], title: t('smallBusiness.sectionTwoTitle'), description: t('smallBusiness.sectionTwoDescription') },
        { id: 3, icon: featureIcons[2], title: t('smallBusiness.sectionThreeTitle'), description: t('smallBusiness.sectionThreeDescription') },
    ];

    return(
        <>
            {/* Features */}
            <section className="niche-features sp-90">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <h2 className="h-1 h-bold mb-20">
                                {t('smallBusiness.featuresHeading')}
                            </h2>
                            <p className="niche-feature-desc" style={{ maxWidth: '600px', margin: '0 auto 20px' }}>
                                {t('smallBusiness.introOne')}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {features.map(f => (
                            <div className="col-lg-4" key={f.id}>
                                <div className="niche-feature-card">
                                    <div className="niche-feature-icon">{f.icon}</div>
                                    <h3 className="niche-feature-title">{f.title}</h3>
                                    <p className="niche-feature-desc">{f.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="niche-cta-section sp-90">
                <div className="container">
                    <h2 className="h-1 h-bold niche-cta-title">
                        {t('smallBusiness.ctaTitle')}
                    </h2>
                    <p className="niche-cta-description">
                        {t('smallBusiness.ctaDescription')}
                    </p>
                    <Buttons />
                </div>
            </section>
        </>
    );
}

export default FeatureBusiness;